<template>
  <div class="project-statistics">
    <header class="top-wrap">
      <div class="main-title">统计管理</div>
    </header>
    <main class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="BaseTable"
        tableHeight="100%"
        :tableColumns="tableColumns"
        :tableData="filterData"
        :pageInfo="pageInfo"
      >
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" width="160">
            <template v-slot="scope">
              <el-button @click.stop="handleDelete(scope.row)" type="danger" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
        </template>
      </BaseTable>
    </main>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import { tableColumns } from "./static"

export default {
  name: "project-statistics",
  components: { BaseTable },
  data() {
    return {
      tableColumns,
      showTable: false,
      filterData: [],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      }
    }
  },
  created() {
    setTimeout(() => {
      this.showTable = true
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.project-statistics {
}
</style>
